<!--  -->
<template>
 <div class="material">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
          <BreadcrumbItem>管理</BreadcrumbItem>
          <BreadcrumbItem>展团申请</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">展团申请</div>
      </div>
      <div style="display: flex">
        <div class="header-tool-box" @click="editpavilionApplyFile">
             <Upload
            :action="uploadUrl2"
            :show-upload-list="false"
            :default-file-list="defaultList"
            :on-success="handleSuccess"
            :format="['doc', 'docx']"
            :max-size="2048"
            :on-format-error="handleFormatError"
            :on-exceeded-size="handleMaxSize"
            :before-upload="handleBeforeUpload"
          >
            <div class="htb-item">
              <span class="htb-add">+</span>
              <span>上传/修改申请表</span>
            </div>
          </Upload>
        </div>
        <div class="header-tool-box">
          <Upload
            :action="uploadUrl2"
            :show-upload-list="false"
            :default-file-list="defaultList1"
            :on-success="handleSuccess1"
            :format="['doc', 'docx']"
            :max-size="2048"
            :on-format-error="handleFormatError1"
            :on-exceeded-size="handleMaxSize1"
            :before-upload="handleBeforeUpload"
          >
            <div class="htb-item">
              <span class="htb-add">+</span>
              <span>上传/修改英文申请表</span>
            </div>
          </Upload>
        </div>
      </div>
    </div>
    <div class="layout-content" style="background: transparent">
      <Table :border="false" row-key="id" :columns="columns" :data="list">
        <template slot-scope="{ row, index }" slot="companyName">{{
          row.name
        }}</template>
        <template slot-scope="{ row, index }" slot="applyTerUrl">{{
          row.applyTermUrl
        }}</template>
        <!-- <template slot-scope="{ row, index }" slot="applyFileLink"><a :href="row.applyFileLink" download>{{row.applyFileLink}}</a></template> -->

        <template slot-scope="{ row, index }" slot="button">
            <Button @click="copyUrl(row.applyTermUrl)">复制链接</Button>
         
        </template>

      </Table>
      <div
        class="my-page"
        v-if="totalCount > pageSize"
        style="margin: 20px; text-align: center"
      >
        <Page
          show-total
          show-elevator
          :page-size="pageSize"
          :current="pageIndex"
          :total="totalCount"
          @on-change="changePage"
          @on-page-size-change="changePageSize"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters} from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          title: "展团名称",
          key: "companyName",
          slot: "companyName",
          align: "center",
          width:320
        },
        {
          title: "报名链接",
          key: "applyTerUrl",
          slot: "applyTerUrl",
          align: "left",
          width:720
        },
        {
          title: "操作",
          key: "button",
          slot: "button",
          
          align: "left",
        },
      ],
      list: [],
      pageIndex: 1,
      pageSize: 20,
      totalCount: 0,
      defaultList: [],
      defaultList1: [],
      fileId: "",
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    this.init();
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  computed: {
    ...mapGetters({
       uploadUrl2: "getUploadUrl2",
       formHeaders: "getFormHeaders",
    }),
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
  },
  methods: {
    ...mapActions({
      getList: "hostSetModule/getPavilion",
      getApplyConfig:"hostCommonModule/getApplyConfig",
      setApplyConfig:"hostCommonModule/setApplyConfig",
    }),
    async init() {
      let data = await this.getList(this.exhibitionInfo.id);
      console.log(data,'data');
      if(data){
          this.list=data
      }
    },
    copyUrl(applyTermUrl){
       this.$Message.success('复制成功')
        const input = document.createElement('input')
        document.body.appendChild(input)
        input.setAttribute('value',applyTermUrl)
        input.select()
        if (document.execCommand('copy')) {
          document.execCommand('copy')
        }
        document.body.removeChild(input)
    },
    editpavilionApplyFile(){

    },
    //上传成功
    async handleSuccess(res, file){
      console.log(res,'ressssss',file,'file')
      let data1=await this.getApplyConfig()
      if(data1){
        this.fileId=data1.id
      }
      let opt={
        Id:this.fileId,
        SetValues:{
          FileApplyTableTerm:res.list[0],
          FileApplyTableTermName:file.name
        }
      }
      let data= await this.setApplyConfig(opt)
      this.$Notice.success({
        title: "上传成功",
        desc: "文档已上传成功！"
      });
    },
        //英文上传成功
    async handleSuccess1(res, file){
      console.log(file,'文件');
      let data1=await this.getApplyConfig()
      if(data1){
        this.fileId=data1.id
      }
      let opt={
        Id:this.fileId,
        SetValues:{
          FileApplyTableTermEn:res.list[0],
          FileApplyTableTermEnName:file.name 
        }
      }
      let data= await this.setApplyConfig(opt)
      this.$Notice.success({
        title: "上传成功",
        desc: "文档已上传成功！"
      });
    },
    //上传失败
    handleFormatError(){
      this.$Notice.warning({
        title: "文件格式是不正确的",
        desc: "请上传word格式的文件"
      });
    },
            //上传失败
    handleFormatError1(){
      this.$Notice.warning({
        title: "文件格式是不正确的",
        desc: "请上传word格式的文件"
      });
    },
    //上传大小限制
    handleMaxSize(){
      this.$Notice.warning({
        title: "文件大小超过限制",
        desc: "请上传小于2M的文档"
      });
    },
    //上传大小限制
    handleMaxSize1(){
      this.$Notice.warning({
        title: "文件大小超过限制",
        desc: "请上传小于2M的文档"
      });
    },
        //上传前钩子函数
    handleBeforeUpload(){

    },
  },
};
</script>
<style scoped lang="scss">
.header-tool-utils {
  margin-top: 20px;
  button {
    margin-right: 20px;
  }
}
.cate-item {
  width: 200px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; // 显示的行数
  overflow: hidden;
}
.layout-content {
  table {
  }
}
</style>

<style lang="scss">
.cate-item {
  width: 200px;
  &:hover {
    color: #1890ff;
  }
}
.cate-pop-item {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  margin-top: 6px;
  .cate-brand {
    display: inline-block;
    border: solid 1px #f0f0f0;
    background-color: #f5f5f5;
    padding: 0 6px;
    margin-right: 6px;
    margin-bottom: 6px;
    color: #333;
    :hover {
      color: #333;
    }
    &-close {
      font-size: 21px;
      position: relative;
      top: 1px;
    }
  }
}
</style>